import {
  merchantKnowledgeArticleSchema,
  merchantKnowledgeAvailabilitySchema,
  merchantKnowledgeDraftSchema,
} from "@redotech/shopper-agent-knowledge-common/merchant-knowledge-view";
import * as z from "zod";

export const createKnowledgeArticle = {
  name: "createKnowledgeArticle" as const,
  input: z
    .object({
      draft: merchantKnowledgeDraftSchema,
      /** Omitted means DRAFT, so nothing goes live by accident. */
      availability: merchantKnowledgeAvailabilitySchema.optional(),
    })
    .strict(),
  output: merchantKnowledgeArticleSchema,
};
